'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconRemove = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M.439 21.44a1.5 1.5 0 0 0 2.122 2.121l9.262-9.261a.25.25 0 0 1 .354 0l9.262 9.263a1.5 1.5 0 1 0 2.122-2.121L14.3 12.177a.25.25 0 0 1 0-.354l9.263-9.262A1.5 1.5 0 0 0 21.439.44L12.177 9.7a.25.25 0 0 1-.354 0L2.561.44A1.5 1.5 0 0 0 .439 2.561L9.7 11.823a.25.25 0 0 1 0 .354z' })
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M23.5 24a.5.5 0 0 1-.354-.146L12 12.707.854 23.854a.5.5 0 0 1-.708-.707L11.293 12 .147.854A.5.5 0 0 1 .854.146L12 11.293 23.147.146a.497.497 0 0 1 .707 0 .5.5 0 0 1 0 .707L12.707 12l11.146 11.146A.5.5 0 0 1 23.5 24z' })
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M19.5 20.25a.743.743 0 0 1-.53-.22L12 13.061l-6.97 6.97a.744.744 0 0 1-1.06 0 .752.752 0 0 1 0-1.061L10.94 12 3.97 5.03c-.142-.141-.22-.33-.22-.53s.078-.389.22-.53c.141-.142.33-.22.53-.22s.389.078.53.22L12 10.94l6.97-6.97a.744.744 0 0 1 1.06 0c.142.141.22.33.22.53s-.078.389-.22.53L13.061 12l6.97 6.97a.75.75 0 1 1-.531 1.28z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconRemove.displayName = 'IconRemove';
exports.default = IconRemove;